import { render, staticRenderFns } from "./MakeFlag.vue?vue&type=template&id=420d51a6&"
import script from "./MakeFlag.vue?vue&type=script&lang=js&"
export * from "./MakeFlag.vue?vue&type=script&lang=js&"
import style0 from "./MakeFlag.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports